<template>
  <b-columns is-multiline>
    <b-column class="is-full">
      <b-field>
        <b-input
          v-model="filter"
          type="text"
          icon="search"
          placeholder="Search"
        />
      </b-field>
    </b-column>
    <b-column>
      <loading-spinner
        v-if="loadingAgents"
        size="3x"
      />
      <agent-list-item
        v-else
        v-for="agent in filteredAgents"
        :key="agent.id"
        :agent="agent"
      />
    </b-column>
  </b-columns>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AgentListItem from './AgentListItem'

const filterAgent = (value) => (agent) => {
  return agent.name.toLowerCase().includes(value) || agent.trivial_name.toLowerCase().includes(value)
}

export default {
  components: {
    AgentListItem,
  },
  mounted () {
    if (this.agents.length === 0) {
      this.fetchAgents()
    }
  },
  data () {
    return {
      filter: ''
    }
  },
  computed: {
    ...mapGetters(['agents', 'loadingAgents']),
    filteredAgents () {
      return this.filter ? this.agents.filter(filterAgent(this.filter.toLowerCase())) : this.agents
    }
  },
  methods: {
    ...mapActions(['fetchAgents'])
  }
}
</script>
